import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

class Impuestos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "Código",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Porcentaje",
                    id: "Porcentaje",
                    accessor: d => d.Porcentaje,
                    show: true,
                    width: 100,
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                         onChange={event => onChange(event.target.value)}
                         style={{ width: "100%" }}
                         value={filter ? filter.value : ""}>
                         <option value="">TODOS</option>
                         <option value={"True"}>SI</option>
                         <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 100,
                    className:"text-center",
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                outerFilter={[{id:"DeBaja", lookup:"exact", value:"False"}]}
                apiUrl={api.gestion.generales.impuestos}
                columns={this.state.columns}
                title={"Impuestos"}
            />
        );
    }
}

export default Impuestos;



// WEBPACK FOOTER //
// ./src/views/Gestion/Generales/Impuestos/Impuestos.js